import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-screen flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20precision%20metal%20manufacturing%20facility%20with%20advanced%20CNC%20machinery%2C%20precision%20mold%20parts%20production%2C%20clean%20industrial%20environment%20with%20metallic%20surfaces%2C%20professional%20lighting%2C%20and%20high-tech%20equipment%20representing%2030%20years%20of%20expertise%20in%20metal%20fabrication%20industry&width=1920&height=1080&seq=hero-precision-manufacturing&orientation=landscape')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
        <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <div className="mb-6">
            <span className="inline-block bg-gradient-to-r from-amber-400 to-yellow-500 text-gray-900 px-6 py-2 rounded-full text-sm font-bold tracking-wider">
              45年以上の実績と信頼
            </span>
          </div>
          <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-amber-300 via-yellow-200 to-amber-300 bg-clip-text text-transparent leading-tight">
            製造業のすべての<br />お困りごとを解決
          </h1>
          <p className="text-xl md:text-2xl mb-4 max-w-4xl mx-auto text-gray-100 leading-relaxed">
            経営・運営・製造に関わるあらゆる課題に対応<br />
            精密金型パーツ会社を45年以上経営してきた代表が、<br />
            豊富な経験と確かな技術でお客様をサポートします
          </p>
          <p className="text-lg mb-10 max-w-3xl mx-auto text-amber-200 font-semibold">
            金属加工から経営支援まで、ワンストップでお応えします
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/contact" 
              className="bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 hover:from-amber-600 hover:via-yellow-600 hover:to-amber-600 text-gray-900 px-10 py-5 rounded-lg font-bold text-lg transition-all shadow-2xl hover:shadow-amber-500/50 cursor-pointer whitespace-nowrap"
            >
              お問い合わせ
            </a>
            <a 
              href="/company" 
              className="border-2 border-amber-400 text-amber-400 hover:bg-amber-400 hover:text-gray-900 px-10 py-5 rounded-lg font-bold text-lg transition-all cursor-pointer whitespace-nowrap"
            >
              会社について
            </a>
          </div>
        </div>
      </section>

      {/* Company Mission */}
      <section className="py-24 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold bg-gradient-to-r from-gray-800 via-gray-700 to-gray-800 bg-clip-text text-transparent mb-6">
              メタルリンクの使命
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto mb-8"></div>
            <p className="text-2xl text-gray-700 max-w-4xl mx-auto leading-relaxed font-medium">
              製造業の経営・運営・製造に関わる<strong className="text-amber-600">すべてのお困りごと</strong>を解決するために設立された会社です
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="bg-white rounded-xl shadow-xl p-8 border-t-4 border-amber-500 hover:shadow-2xl transition-all">
              <div className="w-20 h-20 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-xl flex items-center justify-center mb-6 shadow-lg mx-auto">
                <i className="ri-line-chart-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">経営支援</h3>
              <p className="text-gray-600 text-center leading-relaxed">
                45年以上の経営経験を活かし、製造業の経営課題を解決します
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-xl p-8 border-t-4 border-gray-500 hover:shadow-2xl transition-all">
              <div className="w-20 h-20 bg-gradient-to-br from-gray-400 to-gray-600 rounded-xl flex items-center justify-center mb-6 shadow-lg mx-auto">
                <i className="ri-settings-3-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">運営最適化</h3>
              <p className="text-gray-600 text-center leading-relaxed">
                工場運営から人材管理まで、効率的な運営をサポートします
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-xl p-8 border-t-4 border-amber-500 hover:shadow-2xl transition-all">
              <div className="w-20 h-20 bg-gradient-to-br from-amber-500 to-orange-500 rounded-xl flex items-center justify-center mb-6 shadow-lg mx-auto">
                <i className="ri-hammer-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">製造技術</h3>
              <p className="text-gray-600 text-center leading-relaxed">
                精密金型パーツから金属加工まで、高度な技術力を提供します
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CEO Experience */}
      <section className="py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-amber-600/10 to-transparent"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-block bg-gradient-to-r from-amber-400 to-yellow-500 text-gray-900 px-6 py-2 rounded-full text-sm font-bold mb-6">
                代表の実績
              </div>
              <h2 className="text-5xl font-bold mb-6 bg-gradient-to-r from-amber-300 via-yellow-200 to-amber-300 bg-clip-text text-transparent">
                45年以上の<br />経営実績
              </h2>
              <div className="space-y-6">
                <p className="text-xl text-gray-200 leading-relaxed">
                  代表の大森孝人は、メタルリンク株式会社を設立する前に、<strong className="text-amber-300">45年以上にわたり精密金型パーツ会社を経営</strong>してきました。
                </p>
                <p className="text-lg text-gray-300 leading-relaxed">
                  長年の経営経験で培った技術力、ネットワーク、そして製造業の現場を知り尽くした知見を活かし、お客様のあらゆる課題に対応いたします。
                </p>
                <div className="grid grid-cols-2 gap-6 pt-6">
                  <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-amber-400/30">
                    <div className="text-4xl font-bold text-amber-400 mb-2">45+</div>
                    <div className="text-gray-300">年以上の経営経験</div>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-amber-400/30">
                    <div className="text-4xl font-bold text-amber-400 mb-2">100%</div>
                    <div className="text-gray-300">お困りごと解決</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-amber-400/20 to-transparent rounded-xl"></div>
              <img 
                src="https://static.readdy.ai/image/33e5933f6fefe5b5ffe80f6f6608a7a2/6f0c1b71ef64fb47f2d32b381c0796fe.jpeg"
                alt="代表取締役 大森孝人の経験"
                className="rounded-xl shadow-2xl object-cover w-full h-[500px] border-4 border-amber-400/30"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Comprehensive Services */}
      <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold bg-gradient-to-r from-gray-800 via-gray-700 to-gray-800 bg-clip-text text-transparent mb-6">
              ワンストップソリューション
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto mb-8"></div>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              金属加工から経営支援まで、製造業に関わるすべてのサービスを提供します
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Metal Processing */}
            <div className="bg-gradient-to-br from-white to-gray-50 rounded-xl shadow-lg p-8 hover:shadow-2xl transition-all border border-gray-200 hover:border-amber-400">
              <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-lg flex items-center justify-center mb-6 shadow-lg">
                <i className="ri-hammer-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">精密金属加工</h3>
              <p className="text-gray-600 mb-6">
                45年以上の精密金型パーツ製造の経験を活かした高精度加工
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li className="flex items-center"><span className="text-amber-500 mr-2">●</span> 精密金型パーツ</li>
                <li className="flex items-center"><span className="text-amber-500 mr-2">●</span> 鉄・非鉄金属加工</li>
                <li className="flex items-center"><span className="text-amber-500 mr-2">●</span> 鋳物・表面処理</li>
                <li className="flex items-center"><span className="text-amber-500 mr-2">●</span> 旋盤・MC・研削</li>
              </ul>
            </div>

            {/* Manufacturing Support */}
            <div className="bg-gradient-to-br from-white to-gray-50 rounded-xl shadow-lg p-8 hover:shadow-2xl transition-all border border-gray-200 hover:border-gray-400">
              <div className="w-16 h-16 bg-gradient-to-br from-gray-400 to-gray-500 rounded-lg flex items-center justify-center mb-6 shadow-lg">
                <i className="ri-settings-3-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">製造支援</h3>
              <p className="text-gray-600 mb-6">
                工場運営から品質管理まで、製造現場のあらゆる課題を解決
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li className="flex items-center"><span className="text-gray-500 mr-2">●</span> 木型製作</li>
                <li className="flex items-center"><span className="text-gray-500 mr-2">●</span> 板金・製缶・溶接</li>
                <li className="flex items-center"><span className="text-gray-500 mr-2">●</span> 砥石加工</li>
                <li className="flex items-center"><span className="text-gray-500 mr-2">●</span> 工場塗装</li>
              </ul>
            </div>

            {/* Business Support */}
            <div className="bg-gradient-to-br from-white to-gray-50 rounded-xl shadow-lg p-8 hover:shadow-2xl transition-all border border-gray-200 hover:border-amber-400">
              <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-orange-500 rounded-lg flex items-center justify-center mb-6 shadow-lg">
                <i className="ri-briefcase-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">経営支援</h3>
              <p className="text-gray-600 mb-6">
                45年の経営経験を活かした、製造業の経営課題解決
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li className="flex items-center"><span className="text-amber-500 mr-2">●</span> 人材紹介</li>
                <li className="flex items-center"><span className="text-amber-500 mr-2">●</span> 税理士紹介</li>
                <li className="flex items-center"><span className="text-amber-500 mr-2">●</span> 社会労務士紹介</li>
                <li className="flex items-center"><span className="text-amber-500 mr-2">●</span> 興信所紹介</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-24 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold bg-gradient-to-r from-gray-800 via-gray-700 to-gray-800 bg-clip-text text-transparent mb-6">
              メタルリンクが選ばれる理由
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto mb-8"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl shadow-lg p-8 border-l-4 border-amber-500">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-lg flex items-center justify-center mr-6 flex-shrink-0 shadow-lg">
                  <i className="ri-medal-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-3">45年以上の実績</h3>
                  <p className="text-gray-600 leading-relaxed">
                    精密金型パーツ会社を45年以上経営してきた代表の豊富な経験と確かな技術力で、お客様の課題を確実に解決します。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8 border-l-4 border-gray-500">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-gradient-to-br from-gray-400 to-gray-600 rounded-lg flex items-center justify-center mr-6 flex-shrink-0 shadow-lg">
                  <i className="ri-stack-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-3">ワンストップ対応</h3>
                  <p className="text-gray-600 leading-relaxed">
                    製造・運営・経営のすべての領域をカバー。複数の業者に依頼する手間なく、すべてのお困りごとを一括で解決できます。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8 border-l-4 border-amber-500">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-orange-500 rounded-lg flex items-center justify-center mr-6 flex-shrink-0 shadow-lg">
                  <i className="ri-team-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-3">豊富なネットワーク</h3>
                  <p className="text-gray-600 leading-relaxed">
                    長年の経営で築いた信頼できる専門家ネットワークにより、税理士、社会労務士、人材など、あらゆる分野でサポートします。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8 border-l-4 border-gray-500">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-gradient-to-br from-gray-500 to-gray-700 rounded-lg flex items-center justify-center mr-6 flex-shrink-0 shadow-lg">
                  <i className="ri-map-pin-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-3">地域密着</h3>
                  <p className="text-gray-600 leading-relaxed">
                    福岡県直方市を拠点に、地域の製造業を深く理解し、きめ細やかなサポートを提供します。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-amber-600/10 to-transparent"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-5xl font-bold mb-6 bg-gradient-to-r from-amber-300 via-yellow-200 to-amber-300 bg-clip-text text-transparent">
            製造業のお困りごと、<br />すべて解決します
          </h2>
          <p className="text-xl mb-10 max-w-3xl mx-auto text-gray-200 leading-relaxed">
            経営・運営・製造のどんな課題でもお気軽にご相談ください。<br />
            45年以上の経験を持つ代表が、最適なソリューションをご提案いたします。
          </p>
          <a 
            href="/contact" 
            className="bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 hover:from-amber-600 hover:via-yellow-600 hover:to-amber-600 text-gray-900 px-12 py-5 rounded-lg font-bold text-lg transition-all shadow-2xl hover:shadow-amber-500/50 cursor-pointer whitespace-nowrap inline-block"
          >
            今すぐお問い合わせ
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
